module.exports = __webpack_public_path__ + "img/rosepetal-analysis.7c974995.jpg";